'use client';

import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, IconButton, Typography } from '@/lib/mui';
import Location from '@/components/icons/Location';
import { UserProfile } from '@/services/customerProfileService.types';
import { DeliveryPreferences } from '@/entities/preferences/delivery';
import { getAddressLine } from '@/utils/address';
import AddIcon from '@/components/icons/AddIcon';
import DeliveryIcon from './_icon';
import Section from '../Section';

interface Props {
  user?: UserProfile;
  preferences?: DeliveryPreferences;
}

export default function Delivery({ preferences }: Props) {
  return (
    <Section
      Icon={DeliveryIcon}
      title="Delivery Locations"
      desc="Manage your delivery locations and instructions."
      style={{ marginTop: '2rem' }}
    >
      {preferences?.map((address, index) => (
        <Box key={index} mt={4} display="flex">
          <Box margin="auto">
            <Location />
          </Box>
          <Box ml={2} flex={1}>
            <Typography variant="h6">Home</Typography>
            <Typography variant="body1">
              {getAddressLine(address.deliveryAddress)}
            </Typography>
            <Typography variant="body2">
              {address.instruction.comment}
            </Typography>
          </Box>
          <Box margin="auto">
            <IconButton
              href={`/delivery/edit/${index}`}
              aria-label="delete"
              size="large"
            >
              <EditIcon color="secondary" />
            </IconButton>
          </Box>
        </Box>
      ))}
      <Box mt={4} display="flex">
        <Box margin="auto">
          <Button
            href="/delivery/add"
            style={{ margin: 0, padding: 0, minWidth: 40 }}
          >
            <AddIcon />
          </Button>
        </Box>
        <Box flex={1} margin="auto" ml={2}>
          <Button
            href="/delivery/add"
            variant="text"
            style={{ margin: 0, padding: 0 }}
          >
            <Typography textTransform="none" variant="h6">
              Add Location
            </Typography>
          </Button>
        </Box>
      </Box>
    </Section>
  );
}
